import type { ReactNode } from "react"

// HITL interrupt delivery is now handled by useRewriteStream.
// When an INTERRUPT event arrives in the SSE stream, useRewriteStream calls
// hitl.store.setProposal() directly — no CopilotKit useInterrupt needed.
// This hook is kept for import-path stability; OIOWorkspace calls it for the
// side-effect (marking rewrite status awaiting_approval is now implicit in
// hitl.store.proposal being non-null).
export function useOIORewriteHITL(_onReviseTrigger?: () => void): ReactNode {
  return null
}
